import React, { useRef, useState } from 'react';
import { Mic } from 'lucide-react';
import { toast } from 'sonner';
import { cn } from '../../lib/utils';

export default function VoiceRecorderButton({ onRecorded }) {
  const [recording, setRecording] = useState(false);
  const mediaRecorderRef = useRef(null);
  const chunksRef = useRef([]);

  const start = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mr = new MediaRecorder(stream);
      chunksRef.current = [];

      mr.ondataavailable = (e) => {
        if (e.data && e.data.size > 0) chunksRef.current.push(e.data);
      };

      mr.onstop = () => {
        try {
          const blob = new Blob(chunksRef.current, { type: 'audio/webm' });
          stream.getTracks().forEach((t) => t.stop());
          onRecorded?.(blob);
        } catch (e) {
          // ignore
        }
      };

      mr.start();
      mediaRecorderRef.current = mr;
      setRecording(true);
    } catch (e) {
      toast.error('Microphone permission denied');
    }
  };

  const stop = () => {
    try {
      mediaRecorderRef.current?.stop();
    } finally {
      setRecording(false);
    }
  };

  return (
    <button
      type="button"
      onClick={recording ? stop : start}
      className={cn(
        'w-10 h-10 rounded-full flex items-center justify-center border border-border hover:bg-muted transition',
        recording && 'bg-red-50 border-red-200'
      )}
      title={recording ? 'Stop recording' : 'Record voice'}
    >
      <Mic className={cn('w-5 h-5', recording ? 'text-red-600' : 'text-muted-foreground')} />
    </button>
  );
}
